import { useMemo } from "react";
import { useTheme } from "@emotion/react";
import useBreakpoint from "core/hooks/useBreakpoint";

const useListBreakpoint = () => {
    const theme = useTheme();
    const { minWidth } = useBreakpoint();

    const [bannerHeight, smallBannerHeight, itemBoxWidth] = useMemo(() => {
        switch (true) {
            case minWidth >= theme.breakpoints.sizes["5xl"]:
                return [888, 254, 475];
            case minWidth >= theme.breakpoints.sizes["3xl"]:
                return [619, 254, 400];
            case minWidth >= theme.breakpoints.sizes["xxl"]:
                return [560, 254, 397];
            case minWidth >= theme.breakpoints.sizes["xl"]:
                return [489, 254, 356];
            case minWidth >= theme.breakpoints.sizes["lg"]:
                return [490, 254, 297];
            case minWidth >= theme.breakpoints.sizes["md"]:
                return [600, 254, 297];
            default:
                return [385, 164, 300];
        }
    }, [minWidth, theme.breakpoints.sizes]);

    return { bannerHeight, smallBannerHeight, itemBoxWidth };
};

export default useListBreakpoint;